export default __webpack_public_path__ + "static/media/TOCO-logo.f537b15e.svg";